import { MethodTypeRepository } from '@telespot/domain';

export interface IAnyMethodTypesForResourceQuery {
  /**
   * Returns true if at least one method type references the given resource.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(resourceId: string): Promise<boolean>;
}

export class AnyMethodTypesForResourceQuery implements IAnyMethodTypesForResourceQuery {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(resourceId: string): Promise<boolean> {
    return this.methodTypeRepository.anyForResource(resourceId);
  }
}
